import { CANCELATION_REASONS, EVICTION_STATUSES } from '@homevest/utils/evictions'
import { startCase } from 'lodash'

export type EvictionFormData = {
  status: string
  filed_at: Date | null
  court_date: Date | null
  writ_date: Date | null
  set_out_date: Date | null
  projected_possession_date: Date | null
  file_sent_to_attorney_at: Date | null
  completed_at: Date | null
  canceled_at: Date | null
  cancelation_reason: string
  consent_judgement: boolean
}

export const EMPTY_ERRORS: Record<keyof EvictionFormData, string> = {
  status: '',
  filed_at: '',
  court_date: '',
  writ_date: '',
  set_out_date: '',
  projected_possession_date: '',
  file_sent_to_attorney_at: '',
  completed_at: '',
  canceled_at: '',
  cancelation_reason: '',
  consent_judgement: ''
}

export const STATUS_OPTIONS = Object.values(EVICTION_STATUSES).map((status) => ({
  label: startCase(status),
  value: status
}))

export const CANCELATION_OPTIONS = Object.values(CANCELATION_REASONS).map((reason) => ({
  label: reason,
  value: reason
}))
